import {Button, Modal, Spin} from "antd";
import {useCallback, useState} from "react";
import {useFetch, useStore} from "@vigo/hooks";
import React from "react";

export const DeleteIntegratorModal = ({integratorId, setRefetch}) => {
    const [visible, setVisible] = useState();
    const [recall, setRecall] = useState(false);
    const stores = useStore();
    useFetch({
        defaultDataValue: [],
        fetchFn: stores.integratorStore.deleteIntegrator.bind(null, {
            integratorId: integratorId
        }),
        initialCall: false,
        showLoading: true,
        dependencies: [recall],
        callbackFunc: (result) => {
            if (!result) return;
            setVisible(false);
            setRefetch(prev => !prev);
        }
    });
    const onCancel = useCallback(() => {
        setVisible(false);
    }, []);

    return (
        <div
            style={{
                margin: 5
            }}
        >
            <Modal
                centered
                width={400}
                title={"Silme İşlemi"}
                visible={visible}
                onCancel={onCancel}
                onOk={() => {
                    setRecall(prev => !prev);
                }}
                okText={"Evet"}
                cancelText={"Hayır"}
            >
                Seçilen kaydı silmek istediğinize emin misiniz?
            </Modal>
            <Button
                type={"primary"}
                style={{
                    margin: "3px"
                }}
                danger
                onClick={() => setVisible(true)}
            >
                Sil
            </Button>
        </div>
    );
};
